/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetEventLogging = (payload) => ({
  type: actionTypes.GET_EVENT_LOGGING_DETAILS,
  payload,
});

export const dispatchServiceFailure = (payload) => ({
  type: actionTypes.SERVICE_ERROR,
  payload,
});

export const getEventLogging = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EVENT_LOG_URL, values)
    .then((response) => {
      if (response?.data?.responseEventInquiryLogDetails) {
        dispatch(
          dispatchGetEventLogging(response.data.responseEventInquiryLogDetails)
        );
      } else {
        dispatch(dispatchGetEventLogging([]));
        dispatch(dispatchServiceFailure(true));
      }
    })
    .catch(() => {
      dispatch(dispatchGetEventLogging([]));
    });
};

export const clearReduxEventLoggingScreen = () => (dispatch) => {
  dispatch(dispatchGetEventLogging([]));
};
